import { ROUTES } from '#/config/routes';

import { resolveMaterialSnapshotMtrId } from '#/modules/crmMgmt/customerOrder/helper/materialSnapshotCapabilities';
import {
  formatMaterialSnapshotRequiredQtyForQuery,
  resolveMaterialSnapshotRequiredQty,
} from '#/modules/crmMgmt/customerOrder/helper/resolveMaterialSnapshotRequiredQty';

/**
 * 客訂物料快照（多筆）→ 採購單建立頁 deep link。
 */
export function buildPurchaseOrderCreateUrlFromMaterialSnapshots(line, materials = []) {
  const params = new URLSearchParams();
  const entries = (materials ?? [])
    .map((item) => {
      const mtrId = resolveMaterialSnapshotMtrId(item);
      if (!mtrId) {
        return null;
      }

      return {
        mtrId,
        orderQty: formatMaterialSnapshotRequiredQtyForQuery(
          resolveMaterialSnapshotRequiredQty(line, item),
        ),
      };
    })
    .filter(Boolean);

  if (entries.length === 0) {
    return ROUTES.purchaseOrderCreate;
  }

  params.set('mtr_id', entries.map((entry) => entry.mtrId).join(','));

  const orderQtys = entries.map((entry) => entry.orderQty);
  if (orderQtys.every(Boolean)) {
    params.set('order_qty', orderQtys.join(','));
  }

  const query = params.toString();
  return query ? `${ROUTES.purchaseOrderCreate}?${query}` : ROUTES.purchaseOrderCreate;
}
